const CUSTOMER_LABELS = {
    readOnlyTitle: 'Solicitação de ajuste',
    newTitle: 'Solicitar Ajuste',
    reasonQuestion: 'Por que está solicitando este ajuste?',
    serviceOption: 'Desejo que um serviço já realizado seja ajustado',
};

const STAFF_LABELS = {
    readOnlyTitle: 'Solicitação de correção',
    newTitle: 'Solicitar Correção',
    reasonQuestion: 'Por que está solicitando esta correção?',
    serviceOption: 'Desejo que um serviço já realizado seja corrigido',
};

export const correctionLabelsFor = (isCustomer) => (isCustomer ? CUSTOMER_LABELS : STAFF_LABELS);
